












































































































































































































































































import {
  Component,
  Vue,
  Prop,
  Emit,
} from 'vue-property-decorator';
import moment from 'moment';
import AuthConnector from '@/connector/Auth.vue';
import BankConfigConnector from '@/connector/BankConfig.vue';
import TransactionService from '@/services/TransactionService';
import BankService from '@/services/BankService';
import DepositForm from '@/components/DepositForm.vue';
import BaseDataTable from '@/components/BaseDataTable.vue';
import HengPayForm from '@/components/HengPayForm.vue';
import BigPayForm from '@/components/BigPayForm.vue';
import DepositChoice from '@/components/DepositChoice.vue';

const transactionService = new TransactionService();
const bankService = new BankService();

@Component({
  components: {
    AuthConnector,
    DepositForm,
    BaseDataTable,
    BankConfigConnector,
    HengPayForm,
    BigPayForm,
    DepositChoice,
  },
})
export default class LoginDialog extends Vue {
  @Prop({ type: Boolean, required: true }) open: boolean|undefined;

  public banks: Array<any> = [];

  public hasTurnover: boolean = false;

  public loading: boolean = false;

  public showDepositForm: boolean = false;

  public depositMethod: string = 'slip'

  get dialog() {
    return this.open;
  }

  set dialog(value) {
    this.close();
  }

  // eslint-disable-next-line class-methods-use-this
  get depositListUrl() {
    return `${process.env.VUE_APP_API_ENDPOINT}/transactions/deposit`;
  }

  @Emit('close-dialog')
  // eslint-disable-next-line class-methods-use-this
  close() {
    return false;
  }

  openQrForm() {
    this.showDepositForm = true;
  }

  // eslint-disable-next-line class-methods-use-this
  public formatDate(time: number) {
    return moment(time).format('YYYY-MM-DD HH:mm:ss');
  }

  // eslint-disable-next-line class-methods-use-this
  public async copyAccountNumber(id: string) {
    const copyText = document.getElementById(id);
    if (copyText) {
      const value = copyText?.innerText;
      window.navigator.clipboard.writeText(value);
      this.$store.commit('Snackbar/showNotification', { message: `คัดลอกเลขบัญชี ${value} แล้ว`, error: false });
    }
  }

  get depositData() {
    // eslint-disable-next-line max-len
    const data = (this.$refs.DEPOSIT_FORM as Vue & { getFormData: () => any }).getFormData();
    return data;
  }

  // eslint-disable-next-line class-methods-use-this
  public async requestDeposit(data: FormData) {
    try {
      this.loading = true;
      await transactionService.requestDeposit(data);
      this.loading = false;
      this.$store.commit('Snackbar/showNotification', { message: 'ดำเนินการเรียบร้อยแล้ว', error: false });
      (this.$refs.DEPOSIT_FORM as Vue & { resetFormData: () => void }).resetFormData();
      (this.$refs.DEPOSIT_TABLE as Vue & { refreshData: () => void }).refreshData();
    } catch (e) {
      this.$store.commit('Snackbar/showNotification', { message: e.message, error: true });
      this.loading = false;
    }
  }

  async created() {
    const { data } = await bankService.getAllBanks();
    this.banks = [...data];
  }
}
